// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"adf87de2","497":"18ed075f","604":"fde8c5b0","788":"14754792","825":"813e2389","848":"c42cfc2e"}[chunkId] + ".chunk.css";
};